export const baumagazinSubmenuData = (windowWidth) =>
  windowWidth >= 1024
    ? [
        {
          type: "SubmenuLink",
          label: "Wirtschaft und Politik",
          link: "/fachzeitschriften/baumagazin/wirtschaft-politik",
        },
        {
          type: "SubmenuLink",
          label: "Recht",
          link: "/fachzeitschriften/baumagazin/recht",
        },
        {
          type: "SubmenuLink",
          label: "Hochbau",
          link: "/fachzeitschriften/baumagazin/hochbau",
        },
        {
          type: "SubmenuLink",
          label: "Tief- und Straßenbau",
          link: "/fachzeitschriften/baumagazin/tiefbau-strassenbau",
          additional_classes: ["is-hidden-until-widescreen-flex"],
        },
        {
          type: "SubmenuLink",
          label: "Nutzfahrzeuge am Bau",
          link: "/fachzeitschriften/baumagazin/nutzfahrzeuge-am-bau",
          additional_classes: ["is-hidden-until-fullhd-flex"],
        },
        {
          type: "DropdownMenu",
          label: "mehr",
          page: "baumagazin",
          dropdown_menu_items: [
            {
              type: "SubmenuLink",
              label: "Tief- und Straßenbau",
              link: "/fachzeitschriften/baumagazin/tiefbau-strassenbau",
              additional_classes: ["is-hidden-widescreen"],
            },
            {
              type: "SubmenuLink",
              label: "Nutzfahrzeuge am Bau",
              link: "/fachzeitschriften/baumagazin/nutzfahrzeuge-am-bau",
              additional_classes: ["is-hidden-fullhd"],
            },
            {
              type: "SubmenuLink",
              label: "Betriebsführung",
              link: "/fachzeitschriften/baumagazin/betriebsfuehrung",
            },
            {
              type: "SubmenuLink",
              label: "Bauhandwerk",
              link: "/fachzeitschriften/baumagazin/bauhandwerk",
            },
            {
              type: "SubmenuLink",
              label: "Abbruch und Aufbereitung",
              link: "/fachzeitschriften/baumagazin/abbruch",
            },
            {
              type: "SubmenuLink",
              label: "Ingenieurbau",
              link: "/fachzeitschriften/baumagazin/ingenieurbau",
            },
          ],
        },
        {
          type: "SubmenuSpacer",
        },
        {
          type: "SubmenuLink",
          label: "Jobs",
          link: "/fachzeitschriften/jobs-in-der-bauwirtschaft",
        },
        {
          type: "SubmenuSpacer",
        },
        {
          type: "BfzLogo",
          link: "/fachzeitschriften/baumagazin",
          page: "baumagazin",
          title: "B_I baumagazin Logo",
        },
      ]
    : [
        {
          type: "DropdownMenuMobile",
          label: "Themen",
          page: "baumagazin",
          dropdown_menu_items: [
            {
              type: "SubmenuLink",
              label: "Wirtschaft und Politik",
              link: "/fachzeitschriften/baumagazin/wirtschaft-politik",
            },
            {
              type: "SubmenuLink",
              label: "Recht",
              link: "/fachzeitschriften/baumagazin/recht",
            },
            {
              type: "SubmenuLink",
              label: "Hochbau",
              link: "/fachzeitschriften/baumagazin/hochbau",
            },
            {
              type: "SubmenuLink",
              label: "Tief- und Straßenbau",
              link: "/fachzeitschriften/baumagazin/tiefbau-strassenbau",
            },
            {
              type: "SubmenuLink",
              label: "Nutzfahrzeuge am Bau",
              link: "/fachzeitschriften/baumagazin/nutzfahrzeuge-am-bau",
            },
            {
              type: "SubmenuLink",
              label: "Betriebsführung",
              link: "/fachzeitschriften/baumagazin/betriebsfuehrung",
            },
            {
              type: "SubmenuLink",
              label: "Bauhandwerk",
              link: "/fachzeitschriften/baumagazin/bauhandwerk",
            },
            {
              type: "SubmenuLink",
              label: "Abbruch und Aufbereitung",
              link: "/fachzeitschriften/baumagazin/abbruch",
            },
            {
              type: "SubmenuLink",
              label: "Ingenieurbau",
              link: "/fachzeitschriften/baumagazin/ingenieurbau",
            },
          ],
        },
        {
          type: "BfzLogo",
          link: "/fachzeitschriften/baumagazin",
          page: "baumagazin",
          width: "150px",
          height: "32px",
          title: "B_I baumagazin Logo",
        },
      ]
